import { render } from "./CuratorDetail.vue?vue&type=template&id=6da71534&scoped=true"
import script from "./CuratorDetail.vue?vue&type=script&lang=js"
export * from "./CuratorDetail.vue?vue&type=script&lang=js"

import "./CuratorDetail.vue?vue&type=style&index=0&id=6da71534&lang=scss&scoped=true"

import exportComponent from "/builds/playmob1/songreach/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da71534"]])

export default __exports__